module.exports = {
      id: "lightbulb-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "images/sprites__esh--5511f83cce6776b1962744e4b9d0788f.svg#lightbulb-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__esh/sprites/lightbulb.svg
// module id = /tool/node_modules/svg-sprite-loader/lib/loader.js??ref--13-0!/tool/project/client/src/site__esh/sprites/lightbulb.svg
// module chunks = site__esh